import { authFetch } from "~/services/fetch"

export const registerCopyCommentsTimeline = async ({occurrenceId}) => {
  try {
    await authFetch({
      url: '/occurrence/copy-comments-timeline',
      method: 'POST',
      data: { occurrence_id: occurrenceId },
    })
  } catch (error) {
    console.error('Erro ao registrar cópia de comentários na timeline', error)
  }
}

export const saveCommentSortingSettings = async ({settingId, value}) => {
  try {
    const { data } = await authFetch({
      url: '/setting/user/store',
      method: 'POST',
      data: {
        setting_id: settingId,
        value,
      },
    })

    return data
    
  } catch (error) {
    console.error('Erro ao salvar configurações de ordenação de comentários', error)
  }

}